import { Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ADMIN_ROLES, QA_ROLES, QA_DASHBOARD_ROLES, roleNames } from "../constant";
import { resetState } from "../redux/slices/isAuth"; // use existing export

const Unauthorized = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = useSelector((state) => state.auth.role);

  // Determine message based on role
  let title = "403 - Forbidden";
  let message = "You are logged in, but you don’t have permission to access this page.";

  // conditon only for admin and only qa
  //if (!ADMIN_ROLES.includes(role) &&  role !== roleNames.qa ) {
  // conditon only for admin and all qa roles
  if (
    !ADMIN_ROLES.includes(role) &&
    !QA_ROLES.includes(role) &&
    !QA_DASHBOARD_ROLES.includes(role) 
    // &&
    // (role === roleNames.opsTeamLead || role === roleNames.opsLead)
  ) {
    title = "🚧 Feature in Progress";
    message =
      "Your dashboard or role-specific features are under process and will be available soon.";
  }

  const handleLogout = () => {
    dispatch(resetState()); // clear auth state
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("role");
    navigate("/login", { replace: true });
  };

  return (
    <div className="d-flex vh-100 justify-content-center align-items-center bg-light text-center">
      <div>
        <h1 className="display-4 fw-bold text-warning">{title}</h1>
        <p className="lead">{message}</p>

        <Button type="primary" className="mt-3" onClick={handleLogout}>
          Logout
        </Button>
      </div>
    </div>
  );
};

export default Unauthorized;
